import ManageCollectionRoleModal from './ManageCollectionRoleModal.container'
export default ManageCollectionRoleModal
